<template>
  <g>
    <path
      d="M19 7.00018C19 5.90018 18.1 5.00018 17 5.00018H15C14.45 5.00018 14 5.45018 14 6.00018C14 6.55018 14.45 7.00018 15 7.00018H17V9.65018L13.52 14.0002H10V10.0002C10 9.45018 9.55 9.00018 9 9.00018H6C3.79 9.00018 2 10.7902 2 13.0002V16.0002H4C4 17.6602 5.34 19.0002 7 19.0002C8.66 19.0002 10 17.6602 10 16.0002H14.48L19 10.3502V7.00018ZM7 17.0002C6.45 17.0002 6 16.5502 6 16.0002H8C8 16.5502 7.55 17.0002 7 17.0002Z"
    />
    <path
      d="M9 6.00018H6C5.45 6.00018 5 6.45018 5 7.00018C5 7.55018 5.45 8.00018 6 8.00018H9C9.55 8.00018 10 7.55018 10 7.00018C10 6.45018 9.55 6.00018 9 6.00018Z"
    />
    <path
      d="M19 13.0002C17.34 13.0002 16 14.3402 16 16.0002C16 17.6602 17.34 19.0002 19 19.0002C20.66 19.0002 22 17.6602 22 16.0002C22 14.3402 20.66 13.0002 19 13.0002ZM19 17.0002C18.45 17.0002 18 16.5502 18 16.0002C18 15.4502 18.45 15.0002 19 15.0002C19.55 15.0002 20 15.4502 20 16.0002C20 16.5502 19.55 17.0002 19 17.0002Z"
    />
  </g>
</template>
